import { render, staticRenderFns } from "./CompanyActivityDisplaySetting.vue?vue&type=template&id=128720a7&scoped=true"
import script from "./CompanyActivityDisplaySetting.vue?vue&type=script&lang=ts"
export * from "./CompanyActivityDisplaySetting.vue?vue&type=script&lang=ts"
import style0 from "./CompanyActivityDisplaySetting.vue?vue&type=style&index=0&id=128720a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128720a7",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/observation/user-header/company-activity-display-setting.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fobservation%2Fuser-header%2FCompanyActivityDisplaySetting.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports